module.exports = __webpack_public_path__ + "static/media/info.8f76bd00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/info.svg
// module id = 351
// module chunks = 0